module.exports = __webpack_public_path__ + "img/FPT24.3942c24a.svg";